export default {
    mounted(el, binding) {
        if (binding.value !== undefined && !binding.value) return
        
        // 1. Resolve the target element (el itself or first focusable child node)
        const target = (el && typeof el.focus === 'function')
            ? el
            : el.querySelector('button, input, select, textarea, [tabindex]')
        
        if (!target) return
        
        // Helper to check if an element is visible and interactive in the DOM
        function isFocusable(node) {
            if (!node || node.disabled) return false
            
            const style = window.getComputedStyle(node)
            if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
                return false
            }
            
            return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)
        }
        
        let attempts = 0
        const maxAttempts = 5
        const intervalTime = 200
        
        const timer = setInterval(() => {
            attempts++
            
            if (isFocusable(target)) {
                target.focus()
                
                // Verify target successfully received focus
                if (document.activeElement === target || attempts >= maxAttempts) {
                    clearInterval(timer)
                }
            } else if (attempts >= maxAttempts) {
                clearInterval(timer)
            }
        }, intervalTime)
    }
}